// extracted by mini-css-extract-plugin
export default {"TopicsBox":"Topics-module__TopicsBox--dLhu_"};